import BaseTextInput from '@components/common/atoms/BaseTextInput';
import { InputAdornment, StandardTextFieldProps, SvgIconProps, TextField } from '@mui/material';
import _ from "lodash";
import { observer } from "mobx-react-lite";
import React from 'react';

interface BaseTextFieldProps extends StandardTextFieldProps {
    field: any,
    icon: React.ReactElement<SvgIconProps> | null | string | undefined
}

const BaseTextField: React.FC<BaseTextFieldProps> = observer((props) => {
    const { field, icon } = props

    return (
        <BaseTextInput
            error={!_.isEmpty(field.error)}
            placeholder={field.placeholder}
            label={field.label}
            helperText={field.error}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        {icon}
                    </InputAdornment>
                ),
            }}
            {...field.bind()}
            {...props}
        />
    );
});

export default BaseTextField;
